import { setComponentMapOverrides } from '@jutro/uiconfig';

import DocumentsUploadComponent from './components/DocumentsUploadComponent/DocumentsUploadComponent';

setComponentMapOverrides(
    {
        DocumentsUploadComponent: { component: 'DocumentsUploadComponent' },
    },
    {
        DocumentsUploadComponent
    }
);

export {
    DocumentsUploadComponent as default
};
